export const applyUpdate = (key, to, update) => {
    return {
        ...to,
        [key]: {
            ...to[key],
            ...update
        }
    };
};
export const onlyTruthy = (value) => {
    const result = {};
    for (const key in value) {
        if (!value[key])
            continue;
        result[key] = value[key];
    }
    return result;
};
